// src/components/Footer.js
import React from "react";

function Footer() {
  return (
    <footer style={styles.footer}>
      <p>© 2025 Benmed Technologies. All rights reserved.</p>
    </footer>
  );
}

const styles = {
  footer: {
    background: "var(--dim-gray)",
    padding: "1rem",
    textAlign: "center",
  },
};

export default Footer;